<template>
  <div class="changelog-content" v-html="renderedContent"></div>
</template>

<script>
import { marked } from "marked"

export default {
  name: "ChangeLog",

  props: {
    content: {
      type: String,
      default: "",
    },
  },

  computed: {
    renderedContent() {
      if (!this.content) return ""
      return marked(this.content)
    },
  },
}
</script>

<style scoped>
.changelog-content {
  font-size: 14px;
  line-height: 1.6;
}

.changelog-content >>> h1 {
  font-size: 1.4em;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #e0e0e0;
}

.changelog-content >>> h1:first-child {
  margin-top: 0;
}

.changelog-content >>> h2 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 1.2em;
  margin-bottom: 0.4em;
}

.changelog-content >>> h3 {
  font-size: 1.05em;
  font-weight: 600;
  margin-top: 1em;
  margin-bottom: 0.3em;
}

.changelog-content >>> p {
  margin-bottom: 0.6em;
}

.changelog-content >>> ul,
.changelog-content >>> ol {
  padding-left: 1.5em;
  margin-bottom: 0.6em;
}

.changelog-content >>> li {
  margin-bottom: 0.25em;
}

.changelog-content >>> code {
  background-color: #f5f5f5;
  padding: 0.15em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
}

.changelog-content >>> strong {
  font-weight: 600;
}
</style>
